import { Fragment } from "react";

import { makeAllUrlsValid } from "@/lib/helpers/make-all-urls-valid";
import { JobDetailsDescriptionProps } from "@/lib/types/jobs.types";

export default function JobDetailsDescription({
  jobPosting,
}: JobDetailsDescriptionProps) {
  const description =
    jobPosting.job_description?.trim() || "No job description provided";

  const isInternalJob = jobPosting.is_internal;

  const cardContent = isInternalJob ? (
    <DescriptionInternal description={description} />
  ) : (
    <DescriptionScraped description={description} />
  );

  return (
    <div className="flex items-start flex-col gap-4">
      <h3 className="text-sm font-bold text-foreground">Job Description</h3>
      <div className="bg-surface-subtle/30 rounded-lg p-5 w-full">
        {cardContent}
      </div>
    </div>
  );
}

type DescriptionContentProps = {
  description: string;
};

function DescriptionInternal({ description }: DescriptionContentProps) {
  const formattedDescription = makeAllUrlsValid(description);

  return (
    <div
      className="text-sm text-ink-emphasis leading-relaxed"
      dangerouslySetInnerHTML={{ __html: formattedDescription }}
    />
  );
}

function DescriptionScraped({ description }: DescriptionContentProps) {
  const paragraphs =
    description
      .split("\n\n")
      .map((paragraph) => paragraph.trim())
      .filter((paragraph) => paragraph.length > 0) || [];

  const renderedContent = paragraphs.map((paragraph, paragraphIndex) => {
    const lines = paragraph.split("\n").map((line) => line.trim());

    return (
      <p key={`paragraph-${paragraphIndex}`} className="text-sm text-justify">
        {lines.map((line, lineIndex) => (
          <Fragment key={`line-${paragraphIndex}-${lineIndex}`}>
            {line}
            {lineIndex < lines.length - 1 && <br />}
          </Fragment>
        ))}
      </p>
    );
  });

  return <div className="flex flex-col gap-4">{renderedContent}</div>;
}
